import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  FormControlLabel,
  Tooltip,
  Switch,
  Box,

} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import _ from "lodash";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { CUSTOM_CONSTANTS } from "Constants";
//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import servicefaretypeapi from "Services/ZoneServicefare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Servicetypecreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [servicedetails , setservicedetails] = useState([]);
  const [addedzone , setaddedzone] = useState([]);
 // Get Services list api





   // Get Services list api
   const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      //console.log('res.data--->',res.data);
      dispatch(hideLoader());
      if (res?.status === 200 ) {
        const serviceOptions = res?.data?.data?.data?.services;
        const zoneOptions = res?.data?.data?.data?.addedzone;
        setservicedetails(Array.isArray(serviceOptions) ? serviceOptions : []);
        setaddedzone(Array.isArray(zoneOptions) ? zoneOptions : []);
      } else {
        setservicedetails([]);
        setaddedzone([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      setservicedetails([]);
      setaddedzone([]);
      //console.log("error fetch service area", err);
    };
    servicefaretypeapi.getexcludedzoneServicesList()
      .then(onSuccess, onFailure);
  });

 useEffect(() => {
  openDialog && getServicetype();
}, [openDialog]);

// convert day object to hh:mm:ss:A

const formatTime = (time) => {
  if (time && time.$isDayjsObject) {
    return dayjs(time).format("hh:mm:ss A");
  }
  return "Invalid Time";
};

const handleAddServicefare = (formValues) => {
  console.log('here');
  dispatch(showLoader("Loading please wait..."));

  let validatationPass = true;
  
  formValues.Daystartingtime = formValues.daystartingtime != null  ? formatTime(formValues.daystartingtime) : null
  formValues.Nightstartingtime =  formValues.nightstartingtime != null ? formatTime(formValues.nightstartingtime) :null
  formValues.Dayendingtime =  formValues.dayendingtime != null ? formatTime(formValues.dayendingtime) :null 
  formValues.Nightendingtime = formValues.nightendingtime != null ? formatTime(formValues.nightendingtime) :null
  formValues.DaystartingtimeWeekend = formValues.daystartingtimeWeekend != null ? formatTime(formValues.daystartingtimeWeekend) : null
  formValues.NightstartingtimeWeekend =formValues.nightstartingtimeWeekend != null ?  formatTime(formValues.nightstartingtimeWeekend) :null
  formValues.DayendingtimeWeekend =  formValues.dayendingtimeWeekend != null ? formatTime(formValues.dayendingtimeWeekend) :null
  formValues.NightendingtimeWeekend =  formValues.nightendingtimeWeekend != null ? formatTime(formValues.nightendingtimeWeekend) : null
  
  formValues.dayRange = "MONDAY-SUNDAY"

 // console.log('formValues-->', formValues);

  const onSuccess = (res) => {
    dispatch(hideLoader());
    if (res?.status === 200 || res?.status === 201) {
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Service Fare Created Successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );

      //console.log("the response data ", res?.data);
      // setProfileDetails([]);
      formik.resetForm();
      handleClose();
      // getProfileDetails();
    }
  };
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Error while create service fare",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("update profile details api", err);
  };

  if (validatationPass) {
    console.log(formValues);
    servicefaretypeapi.addzoneservicefare({ ...formValues }).then(onSuccess, onFailure);
  }
};




  // Formik
  const formik = useFormik({
    initialValues: {
      servicetypes:"",
      daystartingtime: null,
      nightstartingtime: null,
      dayendingtime: null,
      nightendingtime: null,
      daystartingtimeWeekend: null,
      nightstartingtimeWeekend: null,
      dayendingtimeWeekend: null,
      nightendingtimeWeekend: null,
      daybaseprice:"",
      nightbaseprice:"",
      daybasepriceWeekend:"",
      nightbasepriceWeekend:"",
    
      ReverseLocation:false,
      SourceAddress:"",
      DestinationAddress:"",
      // farezone: false,
      // zonepercentage: 0,
    },
    validationSchema: yup.object({
     servicetypes: yup.string().required("service types is required").nullable(),
   
    daystartingtime: yup.string().required("Day starting time is required").nullable(),
    nightstartingtime: yup.string().required("Night starting time is required").nullable(),
    dayendingtime: yup.string().required("Day starting time is required").nullable(),
    nightendingtime: yup.string().required("Night ending time is required").nullable(),
    daystartingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
    nightstartingtimeWeekend: yup.string().required("Night starting time is required").nullable(),
    dayendingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
    nightendingtimeWeekend: yup.string().required("Night ending time is required").nullable(),
    daybaseprice: yup
      .number()
      .typeError("Day base price must be a number")
      .required("Day base price is required"),
    nightbaseprice: yup
      .number()
      .typeError("Night base price must be a number")
      .required("Night base price is required"),

     SourceAddress: yup
      .string()
      .required("Day Source Address is required").nullable(),

     DestinationAddress: yup
      .string()
      .required("Day Destination Address is required").nullable(),
    
    daybasepriceWeekend: yup
      .number()
      .typeError("Day base price must be a number")
      .required("Day base price is required"),
    nightbasepriceWeekend: yup
      .number()
      .typeError("Night base price must be a number")
      .required("Night base price is required"),
   
   
    }),
    enableReinitialize: true,
    onSubmit: handleAddServicefare,
  });

  const zoneOptions = Array.isArray(addedzone) ? addedzone : [];
  const serviceTypeOptions = Array.isArray(servicedetails)
    ? servicedetails
    : [];

  

  //Tabs

  return (
    <>
<Dialog
open={openDialog}
TransitionComponent={Transition}
keepMounted
onClose={handleClose}
maxWidth={"xl"}
aria-describedby="dialog-box"
className={classes.root}
>
<DialogTitle>
<section className={classes.dialogTitleContainer}>
<Typography variant="body1" className={classes.title}>
  Add Zone Fare model
</Typography>
<IconButton aria-label="close" onClick={handleClose}>
  <CloseIcon className={classes.closeIcon} />
</IconButton>
</section>
</DialogTitle>

<DialogContent>

<Grid container spacing={3} rowSpacing={4} columnSpacing={4} className={classes.detailsContainer} >

{/* service details feilds */}

<Grid item xs={12}>
  <Typography  variant="h4">
Add Location Wise Fare
  </Typography>
</Grid>

 <Grid container  spacing={3} rowSpacing={4} columnSpacing={3} style={{ padding: 40}}>
  <Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Source Address : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="SourceAddress"
id="SourceAddress"
label="Source Address"
value={formik?.values?.SourceAddress}
defaultValue={formik?.values?.SourceAddress}
onChange={formik.handleChange}
select
error={
formik?.errors?.SourceAddress &&
formik?.touched?.SourceAddress
}
helperText={
formik?.errors?.SourceAddress &&
formik?.touched?.SourceAddress &&
formik?.errors?.SourceAddress
}
fullWidth
variant="outlined"
size="small"
>
 {zoneOptions.map((service) => (
    <MenuItem key={service._id} value={service._id}>
      {service.locationName}
    </MenuItem>
  ))}
</TextField>
</Grid>


<Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Destination Address : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="DestinationAddress"
id="DestinationAddress"
label="Destination Address"
value={formik?.values?.DestinationAddress}
defaultValue={formik?.values?.DestinationAddress}
onChange={formik.handleChange}
select
error={
formik?.errors?.DestinationAddress &&
formik?.touched?.DestinationAddress
}
helperText={
formik?.errors?.DestinationAddress &&
formik?.touched?.DestinationAddress &&
formik?.errors?.DestinationAddress
}
fullWidth
variant="outlined"
size="small"
>
 {zoneOptions.map((service) => (
    <MenuItem key={service._id} value={service._id}>
      {service.locationName}
    </MenuItem>
  ))}
</TextField>
</Grid>

<Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Service Types : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="servicetypes"
id="servicetypes"
label="Service Types"
value={formik?.values?.servicetypes}
defaultValue={formik?.values?.servicetypes}
onChange={formik.handleChange}
select
error={
formik?.errors?.servicetypes &&
formik?.touched?.servicetypes
}
helperText={
formik?.errors?.servicetypes &&
formik?.touched?.servicetypes &&
formik?.errors?.servicetypes
}
fullWidth
variant="outlined"
size="small"
>
{serviceTypeOptions.map((service) => (
<MenuItem
  key={service.serviceName}
  value={service._id}
>
  {`${service.serviceName}`}
</MenuItem>
))}
</TextField>
</Grid>

<Grid item xs={6} >
<Typography variant="h5" className={classes.tarriflabels} >Reverse Location : </Typography>
</Grid>
<Grid item xs={4} className={classes.detailsContent}>
<TextField
name="ReverseLocation"
id="ReverseLocation"
label="Reverse Location"
value={formik?.values?.ReverseLocation}
defaultValue={formik?.values?.ReverseLocation}
onChange={formik.handleChange}
select
error={
formik?.errors?.ReverseLocation &&
formik?.touched?.ReverseLocation
}
helperText={
formik?.errors?.ReverseLocation &&
formik?.touched?.ReverseLocation &&
formik?.errors?.ReverseLocation
}
fullWidth
variant="outlined"
size="small"
>

<MenuItem
  value={false}
>
 No
</MenuItem>
<MenuItem
  value={true}
>
 Yes
</MenuItem>

</TextField>
</Grid>



 </Grid>






</Grid>

<Grid container spacing={3} rowSpacing={4} columnSpacing={3} className={classes.tarrifContainer}>

<Grid item xs={12}>

 

        <Grid item xs={12} style={{paddingTop:40,paddingBottom:40}}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"MONDAY - THURSDAY TARIFF"}</Typography>
</Grid>
        <Grid container spacing={3} rowSpacing={4} columnSpacing={3}>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Day time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.daystartingtime}
            onChange={(newValue) => formik.setFieldValue("daystartingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.daystartingtime &&
              formik?.touched?.daystartingtime
              }
              helperText={
              formik?.errors?.daystartingtime &&
              formik?.touched?.daystartingtime &&
              formik?.errors?.daystartingtime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<Typography variant="h6"  className={classes.tarrifsubheadings}>Night time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightstartingtime}
            onChange={(newValue) => formik.setFieldValue("nightstartingtime", newValue)}
            renderInput={(params) => <TextField {...params}  
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightstartingtime &&
              formik?.touched?.nightstartingtime
              }
              helperText={
              formik?.errors?.nightstartingtime &&
              formik?.touched?.nightstartingtime &&
              formik?.errors?.nightstartingtime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.dayendingtime}
            onChange={(newValue) => formik.setFieldValue("dayendingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.dayendingtime &&
              formik?.touched?.dayendingtime
              }
              helperText={
              formik?.errors?.dayendingtime &&
              formik?.touched?.dayendingtime &&
              formik?.errors?.dayendingtime
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightendingtime}
            onChange={(newValue) => formik.setFieldValue("nightendingtime", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightendingtime &&
              formik?.touched?.nightendingtime
              }
              helperText={
              formik?.errors?.nightendingtime &&
              formik?.touched?.nightendingtime &&
              formik?.errors?.nightendingtime
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography> 
</Grid>
  <Grid item xs={4}>
  <TextField
name="daybaseprice"
id="daybaseprice"
label="Base price"
value={formik?.values?.daybaseprice}
defaultValue={formik?.values?.daybaseprice}
onChange={formik.handleChange}
error={
formik?.errors?.daybaseprice &&
formik?.touched?.daybaseprice
}
helperText={
formik?.errors?.daybaseprice &&
formik?.touched?.daybaseprice &&
formik?.errors?.daybaseprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightbaseprice"
id="nightbaseprice"
label="Base price"
value={formik?.values?.nightbaseprice}
defaultValue={formik?.values?.nightbaseprice}
onChange={formik.handleChange}
error={
formik?.errors?.nightbaseprice &&
formik?.touched?.nightbaseprice
}
helperText={
formik?.errors?.nightbaseprice &&
formik?.touched?.nightbaseprice &&
formik?.errors?.nightbaseprice
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>





        </Grid>
 
         <Grid item xs={12} style={{paddingTop:50,paddingBottom:50}}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"FRIDAY - SUNDAY TARIFF"}</Typography>
</Grid>
        <Grid container spacing={3} rowSpacing={4} columnSpacing={3}>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Starting Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<Typography variant="h6" className={classes.tarrifsubheadings} >Day time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection

            value={formik?.values?.daystartingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("daystartingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.daystartingtimeWeekend &&
              formik?.touched?.daystartingtimeWeekend
              }
              helperText={
              formik?.errors?.daystartingtimeWeekend &&
              formik?.touched?.daystartingtimeWeekend &&
              formik?.errors?.daystartingtimeWeekend
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<Typography variant="h6"  className={classes.tarrifsubheadings}>Night time</Typography>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightstartingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("nightstartingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params}  
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightstartingtimeWeekend &&
              formik?.touched?.nightstartingtimeWeekend
              }
              helperText={
              formik?.errors?.nightstartingtimeWeekend &&
              formik?.touched?.nightstartingtimeWeekend &&
              formik?.errors?.nightstartingtimeWeekend
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Ending Time : </Typography>
</Grid>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.dayendingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("dayendingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.dayendingtimeWeekend &&
              formik?.touched?.dayendingtimeWeekend
              }
              helperText={
              formik?.errors?.dayendingtimeWeekend &&
              formik?.touched?.dayendingtimeWeekend &&
              formik?.errors?.dayendingtimeWeekend
              }
            size="small" />}
          />
</Grid>
<Grid item xs={4}>
<TimePicker
            ampm={true} // Enables AM/PM selection
            value={formik?.values?.nightendingtimeWeekend}
            onChange={(newValue) => formik.setFieldValue("nightendingtimeWeekend", newValue)}
            renderInput={(params) => <TextField {...params} 
            fullWidth 
            variant="outlined"
            error={
              formik?.errors?.nightendingtimeWeekend &&
              formik?.touched?.nightendingtimeWeekend
              }
              helperText={
              formik?.errors?.nightendingtimeWeekend &&
              formik?.touched?.nightendingtimeWeekend &&
              formik?.errors?.nightendingtimeWeekend
              }
            size="small" />}
          />
</Grid>
</LocalizationProvider>

<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography> 
</Grid>
  <Grid item xs={4}>
  <TextField
name="daybasepriceWeekend"
id="daybasepriceWeekend"
label="Base price"
value={formik?.values?.daybasepriceWeekend}
defaultValue={formik?.values?.daybasepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.daybasepriceWeekend &&
formik?.touched?.daybasepriceWeekend
}
helperText={
formik?.errors?.daybasepriceWeekend &&
formik?.touched?.daybasepriceWeekend &&
formik?.errors?.daybasepriceWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>
  <Grid item xs={4}>
  <TextField
name="nightbasepriceWeekend"
id="nightbasepriceWeekend"
label="Base price"
value={formik?.values?.nightbasepriceWeekend}
defaultValue={formik?.values?.nightbasepriceWeekend}
onChange={formik.handleChange}
error={
formik?.errors?.nightbasepriceWeekendWeekend &&
formik?.touched?.nightbasepriceWeekendWeekend
}
helperText={
formik?.errors?.nightbasepriceWeekendWeekend &&
formik?.touched?.nightbasepriceWeekendWeekend &&
formik?.errors?.nightbasepriceWeekendWeekend
}
fullWidth
variant="outlined"
size="small"
></TextField>
  </Grid>





        </Grid>
   
     
</Grid>
{/* <Grid item xs={12}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }} >{"MONDAY - SUNDAY TARIFF"}</Typography>
</Grid> */}



{/* Zone based fare sections */}

{/* <Grid item xs={12}>
<Typography variant="h5" className={classes.tarrifheading} style={{ textAlign: "center", fontWeight: "bold" }}>Zone based fare </Typography>  
</Grid>
<Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} > Select zone :</Typography>  
</Grid>
<Grid item xs={8}   style={{ display: "flex", justifyContent: "center" }} >
  <Tooltip 
  title={!formik.values.farezone ? "Enable Zone Fare before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
<TextField
  name="zonetypes"
  id="zonetypes"
  label="Zones"
  value={formik.values.zonetypes}
  onChange={formik.handleChange}
  select
  disabled={!formik.values.farezone}   // 👈 Disable if switch OFF
  error={formik.touched.zonetypes && Boolean(formik.errors.zonetypes)}
  helperText={formik.touched.zonetypes && formik.errors.zonetypes}
  fullWidth
  variant="outlined"
  size="small"
>
  {addedzone.map((service) => (
    <MenuItem key={service._id} value={service._id}>
      {service.locationName}
    </MenuItem>
  ))}
</TextField>
</Tooltip>
  </Grid> */}

{/* zonepercentage */}
{/* <Grid item xs={4}>
<Typography variant="h5" className={classes.tarriflabels} >Zone price ( % ) :</Typography>  
</Grid>
<Grid item xs={8}   style={{ display: "flex", justifyContent: "center" }} >
<Tooltip 
  title={!formik.values.farezone ? "Enable Zone Fare before You edit" : ""}
  placement="top"
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ff6b6b",   // light red
        color: "#fff",               // white text
        fontSize: "14px",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      },
    },
    arrow: {
      sx: {
        color: "#ff6b6b", // arrow matches tooltip bg
      },
    },
  }}
  arrow
>
<TextField
  name="zonepercentage"
  id="zonepercentage"
  label="Zone price"
  value={formik.values.zonepercentage}
  onChange={formik.handleChange}
  disabled={!formik.values.farezone}   // 👈 Disable if switch OFF
  error={formik.touched.zonepercentage && Boolean(formik.errors.zonepercentage)}
  helperText={formik.touched.zonepercentage && formik.errors.zonepercentage}
  fullWidth
  variant="outlined"
  size="small"
/>
</Tooltip>
  </Grid> */}


{/* Add Fare button */}      
<Grid item xs={12} className={classes.sbtBtnWrapper}>
<Button variant="contained" onClick={formik?.handleSubmit} >
Add Fare Model
</Button>
</Grid>

</Grid>

</DialogContent>

<Divider />
<DialogActions>
<section className={classes.dialogActions}>
<section className={classes.closeBtn}>
<Button onClick={handleClose}>Close</Button>
</section>
</section>
</DialogActions>
</Dialog>
    </>
  );
};

export default Servicetypecreate;
